export function toCurrencyFormat (num) {
    if (num === '' || !isFinite(num)) {
        return '';
    }
    return Number(num).toLocaleString([], {style: 'currency', currency: "USD"});
}